import Entry from '../components/Entry';
import EntryConfig from '../components/entryconfigType';
import '../Default.css';


const menuItems: EntryConfig[] = [
  {
    img:"/icons/map-solid.svg",
    img_alt: "polandmap",
    link: "/polandmap",
    text: "map of Poland"
  },
  {
    img:"/icons/circle-question-regular.svg",
    img_alt: "quizz",
    link: "/quizz",
    text: "quizz"
  },
  {
    img:"/icons/image-regular.svg",
    img_alt: "photoGame",
    link: "/photoGame",
    text: "photo game"
  },
  {
    img:"/icons/music-solid.svg",
    img_alt: "dance",
    link: "/dance",
    text: "dance & songs"
  },
  {
    img:"/icons/language-solid.svg",
    img_alt: "twisters",
    link: "/twisters",
    text: "tongue twisters"
  },
  {
    img:"/icons/brush-solid.svg",
    img_alt: "designs",
    link: "/designs",
    text: "designs"
  }
]

function Poland() {
    return (
      <>
        <div className="page-title">
          Poland
        </div>
        <div className="navigation-wraper">
          <nav className="navigation-bar">
            {menuItems.map((v,i) => <Entry conf={v} key={i}/>)}
          </nav>
        </div>
      </>
    );
}

export default Poland;